// How a date shows on a screen, the same everywhere.
export enum DateFormat {
    DATE = 'd MMM y',
    DATE_TIME = 'd MMM, h:mm a',
    DATE_TIME_WITH_YEAR = 'd MMM y, h:mm a',
    DATE_TIME_SECONDS = 'd MMM, h:mm:ss a',
    TIME = 'h:mm:ss a',
}
